<template>
  <portal to="modals">
    <transition name="v-modal" appear>
      <div v-show="open" :class="['v-modal']">
        <transition name="v-modal__content--wrapper" appear>
          <div class="v-modal__content--wrapper">
            <div v-if="hasCloseListener" @click="$emit('close')" :class="['v-modal__close']">
              <svg width="10" height="10" xmlns="http://www.w3.org/2000/svg">
                <g
                  stroke="#5C5C5E"
                  stroke-width="1.5"
                  fill="none"
                  fill-rule="evenodd"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M1 9l8-8M9 9L1 1" />
                </g>
              </svg>
            </div>
            <div :class="['v-modal__content', 'p-5']">
              <slot></slot>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </portal>
</template>

<script>
import Vue from "vue";

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    document.addEventListener("keyup", this.closeOnEscape);
  },
  computed: {
    hasCloseListener() {
      return this.$listeners && this.$listeners.close;
    }
  },
  methods: {
    closeOnEscape(event) {
      if (event.keyCode === 27 && this.open) {
        this.$emit("close");
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.closeOnEscape);
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-modal {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1500;
  background-color: rgba(40, 40, 40, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 250ms ease-out;
  overflow-y: auto;

  &-enter,
  &-leave-to {
    opacity: 0;
  }

  &__content--wrapper {
    position: relative;
    width: calc(100% - 40px);
    max-height: 100%;
    transition: opacity 250ms ease-out, transform 250ms ease-out;
    transition-delay: 250ms;

    &:before,
    &:after {
      content: "";
      display: block;
      height: 20px;
    }

    &-enter,
    &-leave-to {
      transform: translateY(20px);
      opacity: 0;
    }

    @include media-breakpoint-up(md) {
      height: auto;
      width: 600px;
    }
  }

  &__content {
    height: auto;
    width: 100%;
    overflow: visible;
    padding: $spacer;
    background-color: #fff;
    margin-bottom: $spacer;
    border-radius: $border-radius;
  }

  &__close {
    position: absolute;
    right: 10px;
    top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1501;
    width: 26px;
    height: 26px;
    background-color: theme-color("gray");
    cursor: pointer;
    transition: background-color 200ms ease-out;
    border-radius: 50%;

    &:hover {
      background-color: darken(theme-color("gray"), 10%);
    }
  }
}
</style>
